import { useCallback } from 'react';
import { isFunction } from 'lodash';

import { useProjectActions } from 'src/store/project';

export const useHandlers = ({ onChange }) => {
  const projectActions = useProjectActions();

  const handleChange = useCallback(
    (event) => {
      if (isFunction(onChange)) {
        onChange(event.target.value);
        return;
      }
      projectActions.setImageAspectRatio(event.target.value);
    },
    [onChange, projectActions]
  );

  return { handleChange };
};
